import { ApiConstant } from './../../utils/api-constant/api-constant.service';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TNKSurveyComponent } from './survey.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TNKUtilitiesModule } from '../../utils/utilities.module';
import { StorageService } from '../../services/storage.service';
import { PlatformService } from '../../services/platform.services';
export class TNKSurveyModule {
/**
 * @return {?}
 */
public static forRoot(): ModuleWithProviders {
    return {
      ngModule: TNKSurveyModule,
      providers: [ApiConstant],
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TNKUtilitiesModule,
    RouterModule,
  ],
  declarations: [TNKSurveyComponent],
  exports: [TNKSurveyComponent],
  providers: [ApiConstant, StorageService, PlatformService],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKSurveyModule_tsickle_Closure_declarations() {
/** @type {?} */
TNKSurveyModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKSurveyModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
